import Vue from 'vue'
import Router from 'vue-router'
import BusinessAgreement from '@/views/userAgreements/BusinessAgreement'
import UserAgreement from '@/views/userAgreements/UserAgreement'
import CustomerAgreement from '@/views/userAgreements/CustomerAgreement'
import MerchantCheckIn from '@/views/userAgreements/MerchantCheckIn'
import registerAgreement from '@/views/userAgreements/registerAgreement'
import Strategy from '@/views/strategy/index'
import StrategyDetail from '@/views/strategy/StrategyDetail'
import RTABusinessAgreement from '@/views/RTA/BusinessAgreement'
import RTAUserAgreement from '@/views/RTA/UserAgreement'
import RTACustomerAgreement from '@/views/RTA/CustomerAgreement'

Vue.use(Router)

export default new Router({
  scrollBehavior: () => ({
    y: 0
  }),
  mode: "history",
  routes: [{
    path: '/strategy/:userType',
    name: 'strategy',
    component: Strategy,
  }, {
    path: '/strategy/:type',
    name: 'strategyDetail',
    component: StrategyDetail
  },
  {
    path: '/businessAgreement',
    name: 'businessAgreement',
    component: BusinessAgreement
  },
  {
    path: '/UserAgreement',
    name: 'UserAgreement',
    component: () => import('@/views/userAgreements/UserAgreement'),
    meta: {
      backShow: false,
      title: '剑琅联盟隐私政策'
    }
  },
  {
    path: '/CustomerAgreement',
    name: 'CustomerAgreement',
    component: () => import('@/views/userAgreements/CustomerAgreement'),
    meta: {
      backShow: false,
      title: '剑琅联盟用户服务协议'
    }
  },
  {
    path: '/selfHelpActivity',
    name: 'selfHelpActivity',
    component: () => import('@/views/RTB/selfHelpActivity'),
    meta: {
      backShow: false,
      title: '活动说明'
    }
  },
  {
    path: '/registerAgreement',
    name: 'registerAgreement',
    component: registerAgreement
  },
  {
    path: '/merchantCheckIn',
    name: 'MerchantCheckIn',
    component: MerchantCheckIn
  },
  {
    path: '/RTA/rtabusinessAgreement',
    name: 'RTABusinessAgreement',
    component: RTABusinessAgreement
  },
  {
    path: '/RTA/UserAgreement',
    name: 'RTAUserAgreement',
    component: RTAUserAgreement
  },
  {
    path: '/RTA/CustomerAgreement',
    name: 'RTACustomerAgreement',
    component: RTACustomerAgreement
  },
  {
    path: '/settlementRules',
    name: 'settlementRules',
    component: () => import('@/views/unionApp/settlementRules'),
    meta: {
      backShow: false,
      title: '结算规则'
    }
  },
  {
    path: '/shopSettlementRules',
    name: 'shopSettlementRules',
    component: () => import('@/views/unionApp/shopSettlementRules'),
    meta: {
      backShow: false,
      title: '门店结算规则'
    }
  },
  {
    path: '/about',
    name: 'about',
    component: () => import('@/views/unionApp/about'),
    meta: {
      backShow: false,
      title: '关于我们'
    }
  },
  {
    path: '/outsideLink',
    name: 'outsideLink',
    component: () => import('@/views/unionApp/outsideLink'),
    meta: {
      backShow: false,
      title: '友盟隐私政策'
    }
  },
  {
    path: '/thirdSDK',
    name: 'thirdSDK',
    component: () => import('@/views/unionApp/thirdSDK'),
    meta: {
      backShow: false,
      title: '第三方接入SDK列表'
    }
  },
  {
    path: '/dialog',
    name: 'dialog',
    component: () => import('@/views/unionApp/dialog'),
    meta: {
      backShow: false,
      title: 'app首页提示dialog信息'
    }
  },
  {
    path: '/rtbAbout',
    name: 'rtbAbout',
    component: () => import('@/views/unionApp/rtbAbout'),
    meta: {
      backShow: false,
      title: '关于我们'
    }
  },
  {
    path: '/RTBThirdSDK',
    name: 'RTBThirdSDK',
    component: () => import('@/views/RTB/thirdSDK'),
    meta: {
      backShow: false,
      title: '第三方接入SDK列表'
    }
  },
  {
    path: '/RTBCustomerAgreement',
    name: 'RTBCustomerAgreement',
    component: () => import('@/views/RTB/CustomerAgreement'),
    meta: {
      backShow: false,
      title: '剑琅联盟用户服务协议'
    }
  },
  {
    path: '/RTBUserAgreement',
    name: 'RTBUserAgreement',
    component: () => import('@/views/RTB/UserAgreement'),
    meta: {
      backShow: false,
      title: '剑琅联盟隐私政策'
    }
  },
  {
    path: '/RTBUserAgreementAndroid',
    name: 'RTBUserAgreementAndroid',
    component: () => import('@/views/RTB/UserAgreementAndroid'),
    meta: {
      backShow: false,
      title: '剑琅联盟隐私政策'
    }
  },
  {
    path: '/RTBDialog',
    name: 'RTBDialog',
    component: () => import('@/views/RTB/RTBDialog'),
    meta: {
      backShow: false,
      title: '新版首页提示dialog信息'
    }
  },
  {
    path: '/privacy',
    name: 'privacy',
    component: () => import('@/views/RTB/privacy'),
    meta: {
      backShow: false,
      title: '新版隐私信息'
    }
  },
  {
    path: '/RTBRulesList',
    name: 'RTBRulesList',
    component: () => import('@/views/RTB/RTBRulesList'),
    meta: {
      backShow: false,
      title: '结算规则列表'
    }
  },
  {
    path: '/RTBSettlementRules',
    name: 'RTBSettlementRules',
    component: () => import('@/views/RTB/RTBSettlementRules'),
    meta: {
      backShow: false,
      title: '项目结算规则'
    }
  },
  {
    path: '/selfPayRules',
    name: 'selfPayRules',
    component: () => import('@/views/RTB/RTBRulesList/selfPayRules'),
    meta: {
      backShow: false,
      title: '自助收银结算规则'
    }
  },
  {
    path: '/goodsSettlementRules',
    name: 'goodsSettlementRules',
    component: () => import('@/views/RTB/RTBRulesList/goodsSettlementRules'),
    meta: {
      backShow: false,
      title: '商品结算规则'
    }
  },
  {
    path: '/platformSettlementRules',
    name: 'platformSettlementRules',
    component: () => import('@/views/RTB/platformSettlementRules'),
    meta: {
      backShow: false,
      title: '平台结算规则'
    }
  },
  {
    path: '/notice',
    name: 'notice',
    component: () => import('@/views/RTA/notice'),
    meta: {
      backShow: false,
      title: '剑琅联盟首页提示信息'
    }
  },
  {
    path: '/meituanAuth',
    name: 'meituanAuth',
    component: () => import('@/views/meituanAuth'),
    meta: {
      backShow: false,
      title: '美团授权'
    }
  }
  ]
});



// WEBPACK FOOTER //
// ./src/router/index.js